/*-------------------------------------------------------------------------------------------
Program     :  PoiwarningDialog.js
Description :  Main program for Map and track for PoiwarningDialog 
Date        :  17/06/2025 
Created By  :  Jelbin
---------------------------------------------------------------------------------------------
TicketNo         Author          Date            ChangeDesc
---------------------------------------------------------------------------------------------
17062025       - Jelbin     - 17/06/2025         Created
---------------------------------------------------------------------------------------------*/
import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

const PoiwarningDialog = ({dlgPoiWarning,handlePOIDlgYes,handlePOIDlgNo}) => {
    
    return (
        <>
            <Dialog open={dlgPoiWarning}>
                <DialogTitle></DialogTitle>
                <DialogContent>
                    <b>This task includes POI. Would you still like to proceed?</b>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handlePOIDlgYes}>
                        YES
                    </Button>
                    <Button onClick={handlePOIDlgNo}>NO</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default PoiwarningDialog;